function safeStorageGet(key)
{
    var value = null;
    try { value = localStorage.getItem(key); } catch (err) { value = null; }
    return value;
}

function quizResumeSlideHref( )
{
    var href        = "/pages/welleasy-quiz";
    var progressRaw = safeStorageGet( "welleasy_onboarding_quiz_progress" );
    var reachedCart = safeStorageGet( "quiz_reached_cart" );
    var parsed      = null;
    var position    = 0;

    if ( progressRaw )
    {
        try
        {
            parsed = JSON.parse( progressRaw );
        }
        catch ( err )
        {
            parsed = null;
        }

        if ( parsed )
        {
            if ( reachedCart )
            {
                href = "/cart";
            }
            else if ( parsed.position == "gift" || parsed.slideIndex == "gift" )
            {
                href = "/pages/welleasy-quiz?slide=gift";
            }
            else
            {
                if ( parsed.position != undefined )
                {
                    position = parseInt( parsed.position, 10 );
                }
                else
                {
                    position = parseInt( parsed.slideIndex, 10 );
                }
                if ( !isNaN( position ) && position > 0 )
                {
                    href = "/pages/welleasy-quiz?slide=" + position;
                }
            }
        }
    }
    return href;
}

function applyQuizButtonState(finishBtn, cartBtn, getStartedBtn)
{
    var quizState = safeStorageGet("welleasy_onboarding_quiz_state");
    var reachedCart = safeStorageGet("quiz_reached_cart");
    var resumeBtn = finishBtn || getStartedBtn;
    var cartTarget = cartBtn || getStartedBtn;

    if (finishBtn != null && finishBtn != getStartedBtn)
    {
        finishBtn.style.display = "none";
    }
    if (cartBtn != null && cartBtn != getStartedBtn)
    {
        cartBtn.style.display = "none";
    }
    if (getStartedBtn != null && getStartedBtn != finishBtn && getStartedBtn != cartBtn)
    {
        getStartedBtn.style.display = "none";
    }

    if (reachedCart)
    {
        if (cartTarget)
        {
            cartTarget.textContent = "View Results";
            cartTarget.href = "/cart";
            cartTarget.style.display = "block";
        }
    }
    else if (quizState)
    {
        if (resumeBtn)
        {
            if (resumeBtn == getStartedBtn)
            {
                resumeBtn.textContent = "Finish Quiz";
            }
            resumeBtn.href = quizResumeSlideHref();
            resumeBtn.style.display = "block";
        }
    }
    else
    {
        if (getStartedBtn)
        {
            getStartedBtn.textContent = "Get Started";
            getStartedBtn.href = "/pages/welleasy-quiz";
            getStartedBtn.style.display = "block";
        }
    }
}

function initQuizResumeBanner()
{
    var path = ( window.location.pathname || "" ).replace( /\/$/, "" );
    if ( path == "/cart" )
    {
        return;
    }
    var banners = document.querySelectorAll(".quiz-resume-banner");
    var navWraps = document.querySelectorAll(".nav-quiz-btn-wrap");
    var i = 0;

    for (i = 0; i < banners.length; i++)
    {
        var banner = banners[i];
        banner.style.display = "none";
    }

    for (i = 0; i < navWraps.length; i++)
    {
        var navWrap = navWraps[i];
        applyQuizButtonState(
            navWrap.querySelector(".nav-quiz-btn--finish"),
            navWrap.querySelector(".nav-quiz-btn--cart"),
            navWrap.querySelector(".nav-quiz-btn--get-started")
        );
    }
}

document.addEventListener("DOMContentLoaded", initQuizResumeBanner);

function isQuizCartCloseContext()
{
    var inQuizFlow = document.getElementById("cartQuizDrawer") != null;
    if (inQuizFlow == false)
    {
        try { inQuizFlow = localStorage.getItem("quiz_reached_cart") != null; } catch (e) { inQuizFlow = false; }
    }
    if (inQuizFlow == false)
    {
        try { inQuizFlow = localStorage.getItem("we_reached_reveal_picks") != null; } catch (e) { inQuizFlow = false; }
    }
    return inQuizFlow;
}


